{
  "INBOX_MGMT": {
    "HEADER": "Saapuneet-kansiot",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Yhdistä uudelleen",
      "FACEBOOK": "Yhteys Facebookiin on vanhentunut tai peruttu. Sivulle lähetetyt viestit eivät tule tähän saapuneet-kansioon, ja vastaukset voivat epäonnistua. Facebook-sivua hallinnoivan henkilön on napsautettava Yhdistä uudelleen ja kirjauduttava Facebookiin.",
      "INSTAGRAM": "Yhteys Instagramiin on vanhentunut tai peruttu. Tilille lähetetyt viestit eivät tule tähän saapuneet-kansioon, ja vastaukset voivat epäonnistua. Napsauta Yhdistä uudelleen ja kirjaudu samalle Instagram-tilille. Eri tili luo uuden saapuneet-kansion.",
      "GOOGLE": "Yhteys Googleen on vanhentunut tai peruttu. Uudet sähköpostit eivät tule tähän saapuneet-kansioon, ja vastaukset voivat epäonnistua. Napsauta Yhdistä uudelleen ja kirjaudu Googleen osoitteella {email}.",
      "MICROSOFT": "Yhteys Microsoftiin on vanhentunut tai peruttu. Uudet sähköpostit eivät tule tähän saapuneet-kansioon, ja vastaukset voivat epäonnistua. Napsauta Yhdistä uudelleen ja kirjaudu Microsoftiin osoitteella {email}.",
      "ALLEGRO": "Yhteys Allegroon on vanhentunut tai peruttu. Ostajien viestit eivät tule tähän saapuneet-kansioon, ja vastaukset voivat epäonnistua. Napsauta Yhdistä uudelleen ja kirjaudu Allegroon myyjänä {seller}. Eri myyjätili luo uuden saapuneet-kansion.",
      "IMAP_LOGIN": "Postipalvelin hylkää IMAP-kirjautumisen {login}. Uudet viestit eivät tule tähän postilaatikkoon. Tarkista IMAP-käyttäjätunnus ja salasana välilehdellä {tab} ja tallenna ne. Yritämme kirjautua edelleen, ja laatikko toipuu heti, kun kirjautuminen onnistuu.",
      "WHATSAPP": "Yhteys WhatsAppiin on vanhentunut tai peruttu. Asiakkaiden liitteet eivät saavu tähän saapuneet-kansioon, ja vastaukset voivat epäonnistua. Valitse Yhdistä uudelleen, kirjaudu Facebookiin ja valitse numero {phone} uudelleen."
    },
    "LIST": {
      "404": "Tähän tiliin ei ole liitetty saapuneet-kansiota.",
      "RECONNECT_REQUIRED": "Yhdistä uudelleen"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Valitse kanava",
        "BODY": "Valitse keskusteluväylä, jonka haluat integroida Chatwotin kanssa."
      },
      "INBOX": {
        "TITLE": "Luo saapet-kansio",
        "BODY": "Todenna tilisi ja luo saapuneet-kansio."
      },
      "AGENT": {
        "TITLE": "Lisää edustaja",
        "BODY": "Lisää edustajia luotuun saapuneet-kansioon."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Kaikki valmiina!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Kansion nimi",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Sivuston nimi",
        "PLACEHOLDER": "Anna sivuston nimi (esim. Acme Oy)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Sisäinen nimi",
        "PLACEHOLDER": "Nimeä saapuneet-kansio siten kuin se näkyy tässä hallintapaneelissa",
        "ERROR": "Anna yksilöllinen sisäinen nimi"
      },
      "FB": {
        "HELP": "PS: Kirjautumalla sisään saamme vain pääsyn sivusi viesteihin. Emme koskaan näe yksityisviestejäsi.",
        "CHOOSE_PAGE": "Valitse sivu",
        "CHOOSE_PLACEHOLDER": "Valitse sivu listasta",
        "INBOX_NAME": "Kansion nimi",
        "ADD_NAME": "Lisää kansiolle nimi",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Valitse arvo",
        "CREATE_INBOX": "Luo saapuneet-kansio"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Jatka Instagramilla",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Yhdistä Instagram-profiilisi",
        "HELP": "Lisätäksesi Instagram-profiilisi kanavaksi sinun täytyy todentaa Instagram-profiilisi napsauttamalla ”Jatka Instagramilla”",
        "ERROR_MESSAGE": "Instagramiin yhdistämisessä tapahtui virhe, yritä uudelleen",
        "ERROR_AUTH": "Instagramiin yhdistämisessä tapahtui virhe, yritä uudelleen",
        "NEW_INBOX_SUGGESTION": "Tämä Instagram-tili oli aiemmin liitetty toiseen saapuneet-kansioon, ja se on nyt siirretty tähän. Kaikki uudet viestit näkyvät jatkossa täällä. Vanha saapuneet-kansio ei enää voi lähettää tai vastaanottaa viestejä tälle tilille.",
        "DUPLICATE_INBOX_BANNER": "Tämä Instagram-tili siirrettiin uuteen Instagram-kanavan saapuneet-kansioon. Et voi enää lähettää tai vastaanottaa Instagram-viestejä tästä saapuneet-kansiosta."
      },
      "TWITTER": {
        "HELP": "Lisätäksesi twitter-profiilin kanavaksesi, sinun tulee autentikoida twitter-tilisi klikkaamalla \"Kirjaudu sisään Twitterillä\" ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Sivuston chat",
        "DESC": "Luo kanava sivustollesi ja ala tarjoamaan tukea asiakkaillesi chat-widgetin kautta.",
        "LOADING_MESSAGE": "Luodaan chat-tukikanavaa",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanavan avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhookin URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Anna kelvollinen URL-osoite"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Sivuston verkkotunnus",
          "PLACEHOLDER": "Anna sivuston verkkotunnus (esim. acme.fi)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Tervetuloa-otsikko",
          "PLACEHOLDER": "Hei siellä!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Tervetulotoivotus",
          "PLACEHOLDER": "Teemme yhteydenoton yksinkertaiseksi. Kysy meiltä mitä vaan tai kerro palautetta."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Tervetuloviesti",
          "PLACEHOLDER": "Acme Oy vastaa tyypillisesti muutamassa tunnissa."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Ota käyttöön tervetulotoivotus",
          "HELP_TEXT": "Lähetä tervehdys viestejä automaattisesti, kun asiakkaat aloittavat keskustelun ja lähettävät ensimmäisen viestin.",
          "ENABLED": "Käytössä",
          "DISABLED": "Pois käytöstä"
        },
        "REPLY_TIME": {
          "TITLE": "Aseta vastausaika",
          "IN_A_FEW_MINUTES": "Muutamassa minuutissa",
          "IN_A_FEW_HOURS": "Muutamassa tunnissa",
          "IN_A_DAY": "Päivän kuluessa",
          "HELP_TEXT": "Vastausaika näytetään chat -widgetissä"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widgetin väri",
          "PLACEHOLDER": "Päivitä widgetissä käytetty pääväri"
        },
        "SUBMIT_BUTTON": "Luo saapet-kansio",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Tilin SID",
          "PLACEHOLDER": "Syötä Twilio-tilisi SID",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "Tämä kenttä on pakollinen",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanavan tyyppi",
          "ERROR": "Ole hyvä ja valitse kanavan tyyppi"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Syötä Twilio-Auth Token",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "CHANNEL_NAME": {
          "LABEL": "Kansion nimi",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "PHONE_NUMBER": {
          "LABEL": "Puhelinnumero",
          "PLACEHOLDER": "Ole hyvä ja syötä puhelinnumero, josta viesti lähetetään.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Sinun täytyy määrittää viestin callback URL Twiliossa tässä mainitun URL:n kanssa."
        },
        "SUBMIT_BUTTON": "Luo Twilio-kanava",
        "API": {
          "ERROR_MESSAGE": "Emme pystyneet todentamaan Twilio tunnuksia, yritä uudelleen"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "INBOX_NAME": {
            "LABEL": "Kansion nimi",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "PHONE_NUMBER": {
            "LABEL": "Puhelinnumero",
            "PLACEHOLDER": "Ole hyvä ja syötä puhelinnumero, josta viesti lähetetään.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Kansion nimi",
            "PLACEHOLDER": "Anna saapuneet-kansion nimi",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "PHONE_NUMBER": {
            "LABEL": "Puhelinnumero",
            "PLACEHOLDER": "Anna puhelinnumero, josta viestit lähetetään.",
            "ERROR": "Anna kelvollinen puhelinnumero, joka alkaa merkillä `+`."
          },
          "SUBMIT_BUTTON": "Luo SMS Brana -kanava",
          "API": {
            "ERROR_MESSAGE": "Emme pystyneet luomaan SMS Brana -kanavaa"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Kansion nimi",
            "PLACEHOLDER": "Anna saapuneet-kansion nimi",
            "ERROR": "Tämä kenttä on pakollinen"
          },
          "PHONE_NUMBER": {
            "LABEL": "Puhelinnumero",
            "PLACEHOLDER": "Anna puhelinnumero, josta viestit lähetetään.",
            "ERROR": "Anna kelvollinen puhelinnumero, joka alkaa merkillä `+`."
          },
          "SUBMIT_BUTTON": "Luo DIDWW-kanava",
          "API": {
            "ERROR_MESSAGE": "Emme pystyneet luomaan DIDWW-kanavaa"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhookin URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Pika-asennus Metan kautta",
          "DESC": "Sinut ohjataan Metaan kirjautumaan WhatsApp Business -tiliisi. Pääkäyttäjän oikeudet helpottavat asennuksen sujumista.",
          "BENEFITS": {
            "EASY_SETUP": "Ei manuaalista määritystä",
            "SECURE_AUTH": "Turvallinen OAuth-pohjainen todennus",
            "AUTO_CONFIG": "Automaattinen webhookin ja puhelinnumeron määritys"
          },
          "SUBMIT_BUTTON": "Yhdistä WhatsApp Businessiin",
          "AUTH_PROCESSING": "Todennetaan Metan kanssa",
          "WAITING_FOR_BUSINESS_INFO": "Viimeistele yrityksen asetukset Meta-ikkunassa...",
          "PROCESSING": "Otetaan WhatsApp Business -tiliäsi käyttöön",
          "CANCELLED": "WhatsApp-rekisteröinti peruutettiin",
          "WAITING_FOR_AUTH": "Odotetaan todennusta...",
          "INVALID_BUSINESS_DATA": "Facebookilta saadut yritystiedot eivät kelpaa. Yritä uudelleen.",
          "SIGNUP_ERROR": "Rekisteröinnissä tapahtui virhe",
          "SDK_LOAD_ERROR": "Facebook SDK:n lataus epäonnistui. Yritä uudelleen.",
          "AUTH_NOT_COMPLETED": "Todennusta ei suoritettu loppuun. Käynnistä prosessi uudelleen.",
          "SUCCESS_FALLBACK": "WhatsApp Business -tili on otettu onnistuneesti käyttöön",
          "RECONNECTED": "WhatsApp-kanava yhdistettiin uudelleen onnistuneesti"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API-rajapinta",
        "DESC": "Integroi API-rajapintaan ja aloita tukemaan asiakkaitasi.",
        "CHANNEL_NAME": {
          "LABEL": "Kanavan nimi",
          "PLACEHOLDER": "Ole hyvä ja anna kanavan nimi",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhookin URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook-URL"
        },
        "SUBMIT_BUTTON": "Luo API-kanava",
        "API": {
          "ERROR_MESSAGE": "Emme pystyneet tallentamaan API-rajapintaa"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce-kanava",
        "DESC": "Integroi Salesforce-kanavaan ja ala tarjota tukea asiakkaillesi.",
        "CHANNEL_NAME": {
          "LABEL": "Kanavan nimi",
          "PLACEHOLDER": "Anna kanavan nimi",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API -osoite",
          "SUBTITLE": "Määritä Salesforce-instanssisi perusosoite.",
          "PLACEHOLDER": "Salesforce API -osoite"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Salesforce-kanavasi Key ID.",
          "PLACEHOLDER": "KEY ID"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Salesforce-kanavasi Secret.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Luo Salesforce-kanava",
        "API": {
          "ERROR_MESSAGE": "Emme pystyneet tallentamaan Salesforce-kanavaa"
        },
        "API_CALLBACK": {
          "TITLE": "Webhookin URL",
          "SUBTITLE": "Sinun täytyy määrittää tässä mainittu webhookin URL Salesforceen."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer-tunniste",
          "SUBTITLE": "Käytä tätä bearer-tunnistetta todennukseen, kun määrität webhookia Salesforcessa."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Ohita sähköpostin lähettäjä",
          "SUBTITLE": "Jos tämä on asetettu, tätä sähköpostiosoitetta käytetään kaikkien lähtevien sähköpostien lähettäjänä keskustelun lähdesähköpostin sijaan.",
          "PLACEHOLDER": "esim. tuki{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro-kanava",
        "DESC": "Yhdistä Allegro-myyjätili ja vastaa sen viestikeskuksen viesteihin yhteyskeskuksessa.",
        "CHANNEL_NAME": {
          "LABEL": "Postilaatikon nimi",
          "SUBTITLE": "Nimi, jonka edustajat näkevät tälle postilaatikolle.",
          "PLACEHOLDER": "Anna postilaatikon nimi",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "SUBMIT_BUTTON": "Kirjaudu sisään Allegrolla",
        "API": {
          "ERROR_MESSAGE": "Allegroon yhdistämisessä tapahtui virhe, yritä uudelleen"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro-kirjautuminen",
          "SUBTITLE": "Myyjätili, jonka viestejä tämä postilaatikko lukee ja joihin se vastaa."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland-kanava",
        "DESC": "Vastaa tikettiviesteihin, joita ostajat lähettävät sinulle Kaufland-markkinapaikalla.",
        "CHANNEL_NAME": {
          "LABEL": "Kanavan nimi",
          "PLACEHOLDER": "Ole hyvä ja anna kanavan nimi",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "32 merkin Client Key Kaufland-myyjätilisi API-asetussivulta.",
          "PLACEHOLDER": "32 merkin avain",
          "ERROR": "Anna 32 merkin Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "64 merkin Secret Key, joka kuuluu Client Key -avaimeen. Kaufland näyttää sen kerran, eikä sitä lähetetä koskaan takaisin tälle sivulle.",
          "PLACEHOLDER": "64 merkin avain",
          "ERROR": "Anna 64 merkin Secret Key"
        },
        "SUBMIT_BUTTON": "Luo Kaufland-kanava",
        "API": {
          "ERROR_MESSAGE": "Emme pystyneet tallentamaan Kaufland-kanavaa"
        },
        "DISCONNECTED": {
          "TITLE": "Yhteys katkaistu",
          "MESSAGE": "Kaufland hylkäsi nämä API-avaimet. Anna Client Key ja Secret Key uudelleen yhdistääksesi tämän postilaatikon."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Sähköpostikanava",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanavan nimi",
          "PLACEHOLDER": "Ole hyvä ja anna kanavan nimi",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "EMAIL": {
          "LABEL": "Sähköposti",
          "SUBTITLE": "Sähköposti, johon asiakkaasi lähettää viestit",
          "PLACEHOLDER": "Sähköposti"
        },
        "SUBMIT_BUTTON": "Luo sähköpostikanava",
        "API": {
          "ERROR_MESSAGE": "Emme pystyneet tallentamaan sähköpostikanavaa"
        },
        "FINISH_MESSAGE": "Aloita välittämällä sähköpostit seuraavaan osoitteeseen."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Kanavan nimi",
          "PLACEHOLDER": "Ole hyvä ja anna kanavan nimi",
          "ERROR": "Tämä kenttä on pakollinen"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Puhelut",
        "DESC": "Määritä, mitkä puhelut näkyvät tässä saapuneet-kansiossa.",
        "NAME": {
          "LABEL": "Kansion nimi",
          "SUBTITLE": "Valitse helposti tunnistettava nimi."
        },
        "PHONE_NUMBER": {
          "LABEL": "Puhelinnumero",
          "SUBTITLE": "Anna tähän saapuneet-kansioon kuuluvat puhelinnumerot, voit lisätä numeroita myöhemmin.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Luo puhelut-saapuneet-kansio",
        "API": {
          "ERROR_MESSAGE": "Emme pystyneet luomaan saapuneet-kansiota"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Chat tukee live-chat-widgetejä, Facebook Messenger, WhatsApp, sähköpostit jne. kanavina. Jos haluat rakentaa mukautetun kanavan, voit luoda sen API-kanavalla. Päästäksesi alkuun, valitse jokin kanava alta."
      },
      "AGENTS": {
        "TITLE": "Edustajat",
        "DESC": "Täällä voit lisätä edustajia hallitsemaan juuri luotua saapuneet-kansiota. Vain näillä valituilla edustajilla on pääsy tähän saapuneet-kansioon. Edustajat, jotka eivät kuulu tähän saapuneet-kansioon, eivät pysty näkemään tai vastaamaan viesteihin tässä saapuneet-kansiossa, kun he kirjautuvat. <br> <b>PS:</b> Jos tarvitset ylläpitäjänä pääsyn kaikkiin saapuneisiin, sinun pitäisi lisätä itsesi edustajaksi kaikkiin laatikoihin, jotka luot.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Valitse edustajat postilaatikolle"
      },
      "DETAILS": {
        "TITLE": "Postilaatikon tiedot",
        "DESC": "Valitse alla olevasta pudotusvalikosta Facebook-sivu, johon haluat muodostaa yhteyden. Voit myös antaa mukautetun nimen saapuneet-kansioon paremman tunnistamisen varmistamiseksi."
      },
      "FINISH": {
        "TITLE": "Nappiin meni!",
        "DESC": "Olet onnistuneesti suorittanut Facebook-sivusi integroinnin. Seuraavalla kerralla kun asiakas lähettää sivullesi viestin, keskustelu ilmaantuu automaattisesti saapuneet-kansioon.<br>Tarjoamme myös sivustolle lisättävän widget skriptin, jonka voit helposti lisätä sivustosi. Kun tämä on sivustollasi, asiakkaat voivat lähettää sinulle viestin suoraan sivustostasi ilman ulkoisen työkalun apua, ja keskustelu näkyy täällä.<br>Makeeta vai mitä? No, me ainakin yrittämme olla :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Varmennetaan sinua Facebookissa...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Jokin meni pieleen, päivitä sivu...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Postilaatikkoa ei voitu luoda. Yritä uudelleen.",
      "CREATING_CHANNEL": "Luodaan postilaatikkoasi...",
      "TITLE": "Määritä postilaatikon tiedot",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Lisää edustaja",
      "ADD_AGENTS": "Lisätään edustajia postilaatikkoon..."
    },
    "FINISH": {
      "TITLE": "Postilaatikkosi on valmis!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Vie minut sinne",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "Olet onnistuneesti lisännyt sivuston chat-widgetin. Kopioi alla näkyvä koodi ja liitä se verkkosivuillesi. Seuraavalla kerralla kun asiakas käyttää live-keskustelua, keskustelu ilmestyy automaattisesti saapuneet-kansioon."
    },
    "REAUTH": "Uudelleenvaltuuta",
    "VIEW": "Näytä",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Saapuneet-kansion asetukset päivitetty onnistuneesti",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automaattinen delegointi päivitetty onnistuneesti",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "lähettäjä",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ei mitään"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Käytössä",
        "DISABLED": "Pois käytöstä"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Ota käyttöön saapuvien sähköpostien synkronointi"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Ota käyttöön mukautettu sähköpostidomain (maksullinen palvelu)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Ota käyttöön Facebook-kommenttien käsittely"
      },
      "SIGNATURE": {
        "TITLE": "HTML-allekirjoitus",
        "SUB_TEXT": "Tämä allekirjoitus lisätään jokaisen tästä saapuneet-kansiosta lähetetyn viestin alatunnisteeseen.",
        "HTML_CONTENT": "HTML-koodi",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} korvataan edustajan nimellä.\n{'{{'}email{'}}'} korvataan viestin lähettäneen edustajan sähköpostiosoitteella.\n{'{{'}position{'}}'} korvataan edustajan asemalla.\n{'{{'}custom_line{'}}'} korvataan edustajan mukautetulla rivillä.\n{'{{'}email_signature_picture{'}}'} korvataan edustajan sähköpostiallekirjoituksen kuvan URL-osoitteella (ei kuvatagilla) — käytä sitä kuvan lähteenä (img-tagin src-määritteenä).",
        "PREVIEW": "Esikatselu"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Maakohtaiset allekirjoitukset",
        "SUB_TEXT": "Vastaus saa ostajan maan allekirjoituksen.",
        "HELP": "Vastaus allekirjoitetaan keskustelun maan mukaan: Kauflandin verkkokaupan, Allegro-tilauksen kauppapaikan tai muuten ostajan kirjoituskielen mukaan. Jos maata ei tunneta tai sille ei ole tässä allekirjoitusta, käytetään yllä olevaa HTML-allekirjoitusta. Kauppapaikat kieltävät linkit verkkosivustoosi ja yhteystiedot, joten käytä vain tervehdystä ja {'{{'}name{'}}'}.",
        "EMPTY": "Maakohtaisia allekirjoituksia ei ole vielä, joten vastauksissa käytetään yllä olevaa HTML-allekirjoitusta.",
        "COUNTRY": "Valitse maa",
        "ADD": "Lisää maakohtainen allekirjoitus",
        "REMOVE": "Poista"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Puhelinnumeron valintaetuliite",
        "PLACEHOLDER": "Anna etuliite oikeaa puhelunohjausta varten (esim. *99)",
        "HELP_TEXT": "Tämä etuliite lisätään automaattisesti yhteystietojen puhelinnumeroiden eteen soitettaessa tästä saapuneet-kansiosta."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Selvitä myöhemmin -painikkeen teksti",
        "PLACEHOLDER": "esim. Selvitämme tämän aiheen sähköpostitse. Haluan nyt kysyä jostain muusta.",
        "HELP_TEXT": "Widgetin painikkeen teksti, jolla kävijä voi jättää nykyisen aiheen ja kysyä jostain muusta. Jos jätät kentän tyhjäksi, käytetään oletustekstiä kävijän kielellä."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Torkuta vastaamattomat puhelut automaattisesti X minuutiksi",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Torkuta vastaamattomat puhelut automaattisesti määritetyksi minuuttimääräksi. Jätä tyhjäksi tai aseta arvoksi 0 poistaaksesi käytöstä."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Ratkaise vastaamaton puhelu X epäonnistuneen takaisinsoiton jälkeen",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Kun vastaamattomaan puheluun on soitettu takaisin X kertaa ilman että asiakas vastaa, puhelu ratkaistaan automaattisesti ja siihen lisätään yksityinen muistiinpano. Jätä tyhjäksi tai aseta arvoksi 0 poistaaksesi käytöstä."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Kysymysehdotukset",
        "SUB_TEXT": "Määritä valmiit kysymykset, joita asiakkaat voivat käyttää ollessaan yhteydessä edustajiisi.",
        "QUESTIONS_LABEL": "Kysymykset",
        "ADD_QUESTION": "Lisää kysymys",
        "REMOVE": "Poista",
        "QUESTION_TEXT": "Kuplassa näytettävä teksti.",
        "QUESTION_TEXT_PLACEHOLDER": "Pakollinen",
        "QUESTION_PAYLOAD": "Teksti, joka lähetetään napsautettaessa.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Valinnainen",
        "NO_BOT_MESSAGE": "Luodaksesi lisää AI-ehdotuksia, yhdistä botti.",
        "BOT_CONNECTED_MESSAGE": "Botin AI-kysymysehdotukset voidaan ottaa käyttöön sen",
        "BOT_SETTINGS_LINK": "asetuksissa"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Vaihtoehtoiset sähköpostiosoitteet",
        "SUB_TEXT": "Lisäosoitteet, joita tämän postilaatikon tulee käsitellä ominaan vastaanottaessaan edelleenlähetettyä postia.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Lisää",
        "REMOVE": "Poista",
        "EMPTY": "Vaihtoehtoisia sähköpostiosoitteita ei ole määritetty.",
        "HELP_TEXT": "Kun sähköposti saapuu johonkin näistä osoitteista vastaanottajana, vastaukset lähetetään samasta osoitteesta lähettäjänä. Varmista, että lähtevä SMTP-palvelimesi sallii lähettämisen näistä osoitteista.",
        "SIGNATURE_LABEL": "Allekirjoitus",
        "PRIMARY_SIGNATURE": "Ensisijainen (oletus)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Lisäallekirjoitukset",
        "SUB_TEXT": "Määritä lisäallekirjoituksia tässä ja liitä ne sitten alla oleviin vaihtoehtoisiin sähköposteihin.",
        "OPTION": "Allekirjoitus {number}",
        "ADD": "Lisää allekirjoitus",
        "REMOVE": "Poista",
        "HELP_TEXT": "Kun vastaus lähetetään vaihtoehtoisesta sähköpostiosoitteesta, käytetään sille määritettyä allekirjoitusta postilaatikon allekirjoituksen sijaan. Vaihtoehtoiset sähköpostit, jotka jätetään asetukseen ”Ensisijainen (oletus)”, käyttävät postilaatikon allekirjoitusta."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Poista",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Tämä saapuneet-kansio on merkitty poistettavaksi",
      "RESTORE_BUTTON_TEXT": "Palauta",
      "CONFIRM": {
        "TITLE": "Vahvista poistaminen",
        "MESSAGE": "Oletko varma että haluat poistaa ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Kyllä, poista ",
        "NO": "Ei, säilytä "
      },
      "API": {
        "SUCCESS_MESSAGE": "Postilaatikko poistettu onnistuneesti",
        "MARKED_FOR_DELETION_MESSAGE": "Saapuneet-kansio merkitty poistettavaksi",
        "RESTORE_SUCCESS_MESSAGE": "Saapuneet-kansio palautettu onnistuneesti",
        "ERROR_MESSAGE": "Postilaatikkoa ei voitu poistaa. Yritä myöhemmin uudelleen.",
        "RESTORE_ERROR_MESSAGE": "Saapuneet-kansiota ei voitu palauttaa. Yritä myöhemmin uudelleen.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Asetukset",
      "COLLABORATORS": "Yhteistyökumppanit",
      "AUTOMATIC_PRIORITY": "Automaattinen prioriteetti",
      "AUTOMATIC_LABELING": "Automaattiset tunnisteet",
      "CONFIGURATION": "Määritykset",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Asetukset",
    "FEATURES": {
      "LABEL": "Ominaisuudet",
      "DISPLAY_FILE_PICKER": "Näytä liitevalitsin widgetissä",
      "DISPLAY_EMOJI_PICKER": "Näytä emojivalitsin widgetissä",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Näytä 'Aloita uusi keskustelu' -painike widgetin otsikossa",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Näytä 'Siirrä asiakaspalvelijalle' -painike widgetin otsikossa",
      "AUTO_CLOSE_OLD": "Merkitse kaikki saman numeron aiemmat puhelut ratkaistuiksi, kun yksi niistä ratkaistaan.",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Osoita vastaamattomat puhelut automaattisesti soitettaessa lähtevä puhelu.",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Salli edustajien lähettää viestejä, kun yhteystieto on offline-tilassa eikä sähköpostijatkuvuus ole käytettävissä."
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger-skripti",
      "MESSENGER_SUB_HEAD": "Aseta tämä painike body-tagiisi",
      "INBOX_AGENTS": "Edustajat",
      "INBOX_TEAMS": "Tiimit",
      "INBOX_COOPERATORS": "Yhteistyökumppanit",
      "SELECT_PLACEHOLDER": "Valitse",
      "AGENTS_OR_TEAMS_INFO": "Voit osoittaa joko edustajia tai tiimejä - ei molempia samanaikaisesti.",
      "INBOX_AGENTS_SUB_TEXT": "Lisää tai poista edustajia tästä saapuneet-kansiosta",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Päivitä",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Ota automaattinen delegointi käyttöön",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Ota CSAT käyttöön jokaisessa viestissä",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Ota käyttöön tai poista käytöstä CSAT-kysely jokaiselle edustajien lähettämälle viestille",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Vastaa sähköpostista",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Asiakkaalle lähetettävät sähköpostit — sekä vastaukset että keskustelukopiot — lähetetään valitun sähköpostisaapuneet-kansion SMTP-asetuksilla valitusta osoitteesta (saapuneet-kansion oma osoite tai jokin sen aliaksista), ja asiakkaan vastaukset saapuvat takaisin sen IMAP-osoitteen kautta.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Keskustelukopiot lähetetään valitun sähköpostisaapuneet-kansion SMTP-asetuksilla valitusta osoitteesta (saapuneet-kansion oma osoite tai jokin sen aliaksista), ja vastaukset saapuvat takaisin sen IMAP-osoitteen kautta.",
      "SHOW_WELCOME_SCREEN": "Näytä tervetuloruutu",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Näytä tervetuloruutu, kun widget avataan. Jos pois käytöstä, widget siirtyy suoraan keskustelunäkymään.",
      "AUTO_CLOSE_PENDING": "Ratkaise AI-keskustelut automaattisesti (tuntia)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Ratkaise AI-keskustelut automaattisesti X tunnin passiivisuuden jälkeen.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Postilaatikon tiedot",
      "INBOX_UPDATE_SUB_TEXT": "Päivitä postilaatikon asetukset",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Ota käyttöön tai poista käytöstä automaattinen keskusteluiden delegointi edustajille.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Vaihda avain",
        "TITLE": "Vaihdetaanko salainen avain?",
        "WARNING": "Nykyinen avain mitätöityy heti, kun vaihdat sen.",
        "WARNING_DETAIL": "Ei ole päällekkäistä siirtymäaikaa, eikä avainta voi palauttaa.",
        "IMPACT": "Palvelimiesi on allekirjoitettava käyttäjät uudella avaimella. Jos käyttäjä on yhä allekirjoitettu vanhalla avaimella, tunnistus epäonnistuu. Jos käyttäjän tunnistus on pakollinen, hän ei voi aloittaa keskustelua.",
        "CONFIRM": "Vaihda avain",
        "CANCEL": "Peruuta",
        "SUCCESS": "Salainen avain vaihdettu onnistuneesti",
        "ERROR": "Salaista avainta ei voitu vaihtaa, yritä uudelleen"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Pakota uusi keskustelu jokaisella widgetin latauksella",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Jos käytössä, widgetin avaaminen uudessa välilehdessä tai ikkunassa aloittaa uuden keskustelun.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Unohda yhteystieto, kun uusi keskustelu aloitetaan",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Jos pois käytöstä, widgetistä aloitettu uusi keskustelu säilyttää edellisen yhteystiedon.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Aloita välittämällä sähköpostit seuraavaan osoitteeseen.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sähköpostin synkronointi",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Ota käyttöön saapuvien sähköpostien automaattinen synkronointi ja lataus tästä saapuneet-kansiosta",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Mukautettu sähköpostiverkkotunnus",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Ota käyttöön mukautetun sähköpostiverkkotunnuksen käyttö lähteville sähköposteille",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Voit lukea lisää täältä.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-kommentit",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Widgetin tila",
      "WIDGET_STATUS_ENABLED": "Käytössä",
      "WIDGET_STATUS_BUSINESS_HOURS": "Käytössä aukioloaikoina",
      "WIDGET_STATUS_DISABLED": "Pois käytöstä",
      "WIDGET_STATUS_HELP_TEXT": "Määritä, milloin widget näytetään verkkosivustosi kävijöille",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "CSAT-kysely ja sähköpostin kieliasetus",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Valitse kieli kaikille asiakkaalle lähetettäville sähköposteille, mukaan lukien CSAT-kyselyt, keskustelukopiot ja sähköposti-ilmoitukset",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Peri tililtä",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-yhteys",
        "SUBTITLE": "Näin tämä saapuneet-kansio on yhdistetty WhatsAppiin.",
        "PROVIDER": "Palveluntarjoaja",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Yhdistetty Metan upotetun rekisteröitymisen kautta",
        "STATUS": "Tila",
        "CONNECTED": "Yhdistetty",
        "RECONNECT_HINT": "Napsauta Yhdistä uudelleen yllä olevassa ilmoituksessa.",
        "PHONE_NUMBER": "Puhelinnumero",
        "BUSINESS_ACCOUNT": "WhatsApp Business -tilin tunnus",
        "OPEN_MANAGER": "Avaa WhatsApp Managerissa",
        "PHONE_NUMBER_ID": "Puhelinnumeron tunnus",
        "TEMPLATES": "Viestimallit",
        "TEMPLATES_COUNT": "{approved}/{total} hyväksytty",
        "TEMPLATES_SYNCED": "Synkronoitu viimeksi {date}",
        "TEMPLATES_NOT_SYNCED": "Ei vielä synkronoitu",
        "MANAGE_TEMPLATES": "Hallitse malleja"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "SLA-käytännöt",
      "SUB_TEXT": "Määritä SLA-vasteajat ja ratkaisuajat kullekin keskustelun prioriteettitasolle.",
      "LOADING": "Ladataan SLA-käytäntöjä...",
      "FIELDS": {
        "ACTIVE": "Aktiivinen",
        "TICKET_PRIORITY": "Keskustelun prioriteetti",
        "FIRST_RESPONSE_TIME": "Ensimmäinen vasteaika",
        "EVERY_RESPONSE_TIME": "Jokainen vasteaika",
        "RESOLUTION_TIME": "Ratkaisuaika",
        "PLACEHOLDER": "esim. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA-käytännöt päivitetty onnistuneesti.",
        "ERROR_MESSAGE": "SLA-käytäntöjä ei voitu päivittää. Yritä uudelleen."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automaattinen prioriteetti",
      "SUB_TEXT": "Määritä automaattinen prioriteetin osoitus keskustelun sisällön perusteella.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Laskutusilmoitus",
        "MESSAGE": "Jokainen prioriteettiarviointi aiheuttaa veloituksen. Tarkista hinnoittelutiedot tilaussuunnitelmastasi."
      },
      "MODE": {
        "OFF": "Pois käytöstä",
        "ALL_MESSAGES": "Käytössä kaikille saapuville viesteille",
        "FIRST_MESSAGE": "Käytössä vain ensimmäiselle saapuvalle viestille"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Prioriteettitasojen määritys",
        "SUB_TEXT": "Määritä, mitkä prioriteettitasot ovat käytössä, ja niiden kuvaukset. Anna selkeät kriteerit, joiden avulla AI voi päättää, milloin tämä prioriteetti tulee osoittaa."
      },
      "DESCRIPTION_LABEL": "Kuvaus",
      "DESCRIPTION_PLACEHOLDER": "Kuvaile keskustelut, jotka merkitään {priority}-prioriteetiksi",
      "SET_AS_DEFAULT": "Aseta oletusprioriteetiksi",
      "MULTIPLE_DEFAULTS_WARNING": "Vain yksi prioriteettitaso voi olla oletuksena. Poista muut oletusvalinnat."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automaattiset tunnisteet",
      "SUB_TEXT": "Määritä automaattinen tunnisteen osoitus keskustelun sisällön perusteella.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Laskutusilmoitus",
        "MESSAGE": "Jokainen tunnisteen arviointi aiheuttaa veloituksen. Tarkista hinnoittelutiedot tilaussuunnitelmastasi."
      },
      "MODE": {
        "OFF": "Pois käytöstä",
        "CONVERSATION_OPEN": "Käytössä, kun keskustelu avataan",
        "CONVERSATION_CLOSE": "Käytössä, kun keskustelu suljetaan",
        "ALL_MESSAGES": "Käytössä jokaisessa viestissä - tilasta riippumatta",
        "FIRST_MESSAGE": "Käytössä ensimmäisessä viestissä - tilasta riippumatta"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Tunnisteiden määritys",
        "SUB_TEXT": "Määritä, mitkä tunnisteet ovat käytettävissä automaattista osoittamista varten, ja niiden kuvaukset. Anna selkeät kriteerit, joiden avulla AI voi päättää, milloin tätä tunnistetta tulee käyttää."
      },
      "DESCRIPTION_LABEL": "Kuvaus",
      "DESCRIPTION_PLACEHOLDER": "Kuvaile keskustelut, jotka merkitään tunnisteella {label}. Jos jätät tämän tyhjäksi, käytetään tunnisteen kuvausta.",
      "NO_LABELS_MESSAGE": "Tunnisteita ei löytynyt. Luo tunnisteita ensin, jotta voit ottaa käyttöön automaattiset tunnisteet.",
      "CREATE_LABELS_LINK": "Luo tunnisteita"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Uudelleenvaltuuta",
      "SUBTITLE": "Facebook-yhteytesi on vanhentunut, ole hyvä ja yhdistä uudelleen Facebook-sivusi jatkaaksesi palveluita",
      "MESSAGE_SUCCESS": "Uudelleenyhdistäminen onnistui",
      "MESSAGE_ERROR": "Tapahtui virhe, yritä uudelleen"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Tallenna kaikkiin saapuneet-kansioihin",
      "SAVE_TO_ALL_TITLE": "Kopioi aukioloajat",
      "SAVE_TO_ALL_CONFIRM": "Tämän lomakkeen asetukset (saatavuuden kytkin, poissaoloviesti, aikavyöhyke ja aukioloajat) kopioidaan kaikkiin muihin saapuneet-kansioihin, paitsi sähköposti- ja puhelinsaapuneet-kansioihin. Haluatko varmasti jatkaa?",
      "SAVE_TO_ALL_CANCEL": "Peruuta",
      "SAVE_TO_ALL_YES": "Kyllä, kopioi kaikkiin",
      "SAVE_TO_ALL_SUCCESS": "Aukioloajat kopioitu kaikkiin muihin saapuneet-kansioihin onnistuneesti",
      "SAVE_TO_ALL_ERROR": "Aukioloaikojen kopiointi muihin saapuneet-kansioihin epäonnistui"
    },
    "PHONE": {
      "TITLE": "Puhelinasetukset",
      "SUBTITLE": "Määritä, mitkä puhelut näkyvät tässä saapuneet-kansiossa.",
      "UPDATE": "Tallenna asetukset",
      "EDIT": {
        "SUCCESS_MESSAGE": "Puhelinasetukset päivitetty"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Puhelinnumerot",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Kirjaudu",
        "PLACE_HOLDER": "Kirjaudu"
      },
      "PASSWORD": {
        "LABEL": "Salasana",
        "PLACE_HOLDER": "Salasana"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Kirjaudu",
        "PLACE_HOLDER": "Kirjaudu"
      },
      "PASSWORD": {
        "LABEL": "Salasana",
        "PLACE_HOLDER": "Salasana"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Sähköpostin toimitettavuus (DNS)",
      "SUB_TITLE": "Tarkistamme verkkotunnuksen {domain} SPF-, DKIM-, DMARC- ja MX-tietueet joka arkipäivä. Kun jokin saa vastaanottavat palvelimet hylkäämään vastauksenne tai siirtämään ne roskapostiin, ylläpitäjät saavat sähköpostin korjausohjeineen.",
      "RUN": "Suorita tarkistus",
      "RUN_SUCCESS": "DNS-tarkistus valmistui",
      "RUN_ERROR": "DNS-tarkistusta ei voitu suorittaa, yritä uudelleen",
      "NOT_CHECKED": "Ei vielä tarkistettu.",
      "CHECKED_AT": "Viimeksi tarkistettu {time}.",
      "DNS_UNAVAILABLE": "Viimeisimmässä tarkistuksessa verkkotunnuksen nimipalvelimet eivät vastanneet. Alla oleva tulos on edellisestä tarkistuksesta.",
      "SENDER": {
        "SMTP": "Vastaukset lähetetään palvelimen {host} kautta.",
        "PLATFORM": "Vastaukset lähetetään palvelimiemme kautta."
      },
      "STATUS": {
        "OK": "Kaikki tietueet ovat kunnossa",
        "WARNING": "Joitakin tietueita voisi parantaa",
        "ERROR": "Vastaukset eivät välttämättä tavoita vastaanottajia",
        "UNKNOWN": "Tuntematon"
      },
      "SEVERITY": {
        "ERROR": "Ongelma",
        "WARNING": "Varoitus"
      },
      "FIX": "Korjaa asia tällä DNS-tietueella:",
      "RECORD_TYPE": "Tyyppi",
      "RECORD_HOST": "Nimi",
      "RECORD_VALUE": "Arvo",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-tietue puuttuu",
          "DESCRIPTION": "Verkkotunnus ei kerro, mitkä palvelimet saavat lähettää sen sähköpostia. Monet postipalvelimet pitävät silloin vastauksianne roskapostina. Lisää SPF-tietue, joka sallii lähettäjän {sender}."
        },
        "spf_multiple": {
          "TITLE": "Verkkotunnuksella on {count} SPF-tietuetta",
          "DESCRIPTION": "Verkkotunnuksella saa olla vain yksi SPF-tietue. Jos niitä on useampi, vastaanottavat palvelimet ohittavat SPF:n ja hylkäävät viestit usein. Yhdistä ne yhdeksi tietueeksi."
        },
        "spf_not_authorized": {
          "TITLE": "SPF ei salli vastauksianne lähettävää palvelinta",
          "DESCRIPTION": "Vastauksenne lähetetään palvelimen {sender} kautta, mutta verkkotunnuksen SPF-tietueessa sitä ei ole lueteltu. Nykyinen tietue: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-tietue vaatii liian monta DNS-kyselyä",
          "DESCRIPTION": "Vastaanottavat palvelimet lopettavat SPF-tarkistuksen {limit} DNS-kyselyn jälkeen, mutta vastauksianne lähettävään palvelimeen {sender} päästään vasta {lookups} kyselyn jälkeen. Vastauksenne eivät läpäise SPF-tarkistusta. Siirrä {sender} tietueen alkuun ja poista include-merkinnät, joita verkkotunnus ei enää käytä."
        },
        "spf_lookups_others": {
          "TITLE": "Osa SPF-tietueen lähettäjistä jää kyselyrajan ulkopuolelle",
          "DESCRIPTION": "SPF-tietue vaatii {lookups} DNS-kyselyä, ja vastaanottavat palvelimet lopettavat {limit} kyselyn jälkeen. Vastauksenne ehditään tunnistaa ja ne läpäisevät tarkistuksen, mutta näiden lähettäjien viestit epäonnistuvat SPF-tarkistuksessa: {senders}. Poista include-merkinnät, joita verkkotunnus ei enää käytä."
        },
        "spf_malformed": {
          "TITLE": "SPF-tietue on virheellinen",
          "DESCRIPTION": "Vastaanottavat palvelimet eivät pysty lukemaan verkkotunnuksen SPF-tietuetta, joten se ei suojaa vastauksianne. Virhe on kohdassa: {terms}. Korvaa tietue korjatulla versiolla."
        },
        "dkim_missing": {
          "TITLE": "DKIM-allekirjoitusta ei ole otettu käyttöön",
          "DESCRIPTION": "Emme löytäneet DKIM-avainta osoitteesta {selectors}. Ilman sitä vastauksianne ei allekirjoiteta, ja ne päätyvät todennäköisemmin roskapostiin. Ota DKIM-allekirjoitus käyttöön verkkotunnukselle sähköpostipalvelun tarjoajanne kautta."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-tietue puuttuu",
          "DESCRIPTION": "Suuret sähköpostipalvelut, kuten Gmail ja Microsoft, edellyttävät DMARC-tietuetta. Ilman sitä vastauksenne päätyvät todennäköisemmin roskapostiin."
        },
        "dmarc_fails": {
          "TITLE": "DMARC käskee vastaanottajia hylkäämään vastauksenne",
          "DESCRIPTION": "Verkkotunnuksen DMARC-käytäntö on ”{policy}”, eivätkä vastauksenne läpäise SPF- tai DKIM-tarkistusta, joten vastaanottajat hylkäävät ne tai siirtävät ne roskapostiin. Korjaa ensin yllä mainitut SPF ja DKIM."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC estää palvelimiemme kautta lähetetyt vastaukset",
          "DESCRIPTION": "Tämä postilaatikko lähettää vastaukset palvelimiemme kautta, mutta verkkotunnuksen DMARC-käytäntö on ”{policy}”, joten vastaanottajat hylkäävät ne tai siirtävät ne roskapostiin. Ota tälle postilaatikolle käyttöön oman postipalvelimenne SMTP."
        },
        "mx_missing": {
          "TITLE": "Verkkotunnuksella ei ole MX-tietuetta",
          "DESCRIPTION": "Ilman MX-tietuetta kukaan ei voi lähettää sähköpostia verkkotunnukseen, joten asiakkaat eivät voi vastata viesteihinne."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Tapahtui virhe, yritä uudelleen"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Sivuston nimi",
          "PLACE_HOLDER": "Anna sivuston nimi (esim. Acme Oy)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Tervetuloa-otsikko",
          "PLACE_HOLDER": "Hei siellä!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Tervetulotoivotus",
          "PLACE_HOLDER": "Teemme yhteydenoton yksinkertaiseksi. Kysy meiltä mitä vaan tai kerro palautetta."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "Muutamassa minuutissa",
          "IN_A_FEW_HOURS": "Muutamassa tunnissa",
          "IN_A_DAY": "Päivän kuluessa"
        },
        "WIDGET_COLOR_LABEL": "Widgetin väri",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Lukemattomien viestien enimmäiskorkeus (px)",
          "PLACE_HOLDER": "Ei rajoitusta",
          "HELP_TEXT": "Rajoita lukemattomien viestien ponnahdusikkunan enimmäiskorkeus pikseleinä. Jätä tyhjäksi oletuskäyttäytymistä varten (ei rajoitusta)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Keskustele kanssamme",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Keskustele kanssamme"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Vastaa tyypillisesti muutamassa minuutissa",
        "IN_A_FEW_HOURS": "Tyypillisesti vastaa muutaman tunnin kuluessa",
        "IN_A_DAY": "Vastaa tyypillisesti päivässä"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Aloita keskustelu",
        "CHAT_INPUT_PLACEHOLDER": "Kirjoita viestisi"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Olemme online-tilassa",
          "OFFLINE": "Olemme tällä hetkellä poissa"
        },
        "USER_MESSAGE": "Hei",
        "AGENT_MESSAGE": "Moi"
      },
      "BRANDING_TEXT": "Palvelun tarjoaa JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Verkkosivusto",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Sähköposti",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API-rajapinta",
      "PHONE": "SIP-puhelin",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
